import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import NumberFormat from 'react-number-format';
// CSS and assets
import './style.scss';
import { CommonInput } from '@src/global/components/common/CommonInput';
// import { CommonInfoTooltipIcon } from '@src/global/components/common/CommonInfoTooltipIcon';
interface ActiveInputFormattedProps {
  inputName: string;
  inputFormat?: string;
  defaultValue?: string;
}

export const ActiveInputFormatted = ({
  inputName,
  inputFormat,
  defaultValue,
}: ActiveInputFormattedProps) => {
  const { field, fieldState } = useController({
    name: inputName,
    defaultValue,
  });

  const { t } = useTranslation('', {
    keyPrefix: 'activeForm',
  });

  return (
    <NumberFormat
      {...field}
      type="text"
      format={inputFormat}
      mask="_"
      id="card_billingaddress_phone"
      customInput={CommonInput}
      label={t(`${inputName}Label`)}
      //labelIcon={<CommonInfoTooltipIcon tooltipText={t('phoneToolTipText')} />}
      isValid={field.value && !fieldState?.error?.message}
      error={!!fieldState?.error}
      errorMessage={fieldState.error?.message}
    />
  );
};
